import { Component, OnDestroy, OnInit } from "@angular/core";
import { NoticeFacade } from "@youm-front/notice/data-access";
import { NoticeEntity } from "@youm-front/notice/domain";
import { ErrorHandlerService } from "@youm-front/utils/error-handler";
import { Subject } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";
import { NoticeFeatureNoticeService } from "../../notice-feature-notice.service";

@Component({
  selector: "app-notice-feature-notice",
  templateUrl: "./notice.component.html"
})
export class NoticeComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly noticeFacade: NoticeFacade,
    private readonly noticeFeatureNoticeService: NoticeFeatureNoticeService
  ) {}

  get isRenderable$() {
    return this.noticeFeatureNoticeService.isRenderable$;
  }

  ngOnInit(): void {
    this.errorHandlerService.error$
      .pipe(
        tap((_) =>
          // TODO https://liveedev.atlassian.net/browse/YOUM-235
          // this.noticeFacade.noticeCreate(
          //   new NoticeCreate1Cmd({
          //     kind: "error",
          //     data: `Internal error ${_.errorId}`
          //   })
          // )
          console.error(_)
        ),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get notices$() {
    return this.noticeFacade.notices$;
  }

  onDelete(notice: NoticeEntity) {
    this.noticeFacade.noticeDelete(notice);
  }
}
